import { render, staticRenderFns } from "./Audi.vue?vue&type=template&id=55ec5648&scoped=true&"
import script from "./Audi.vue?vue&type=script&lang=js&"
export * from "./Audi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec5648",
  null
  
)

export default component.exports